import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'motion/react'
import { cn } from '@/lib/utils'

interface ParallaxImageProps {
    src: string
    alt: string
    className?: string
    priority?: boolean
}

export const ParallaxImage: FC<ParallaxImageProps> = ({
    src,
    alt,
    className,
    priority = false
}): ReactNode => {
    const frameRef = useRef<HTMLDivElement>(null)

    const { scrollYProgress } = useScroll({
        target: frameRef,
        offset: ['start end', 'end start']
    })

    const y = useTransform(scrollYProgress, [0, 1], ['-11.5%', '11.5%'])

    return (
        <div
            ref={frameRef}
            className={cn('relative overflow-hidden', className)}
        >
            <motion.img
                src={src}
                alt={alt}
                loading={priority ? 'eager' : 'lazy'}
                decoding='async'
                style={{ y }}
                className='pointer-events-none absolute inset-x-0 top-[-15%] h-[130%] w-full max-w-none object-cover will-change-transform'
            />
        </div>
    )
}
